import React, { useState, useEffect } from "react"
import styled, { css } from "styled-components"
import { rem } from "polished"
import { motion } from "framer-motion"
import { Row, Col } from "react-flexbox-grid"

import { ReactComponent as ArrowLeft } from "../../../assets/images/spc-arrow-left.svg"
import { ReactComponent as ArrowRight } from "../../../assets/images/spc-arrow-right.svg"

import Slide from "./single-slide"

const SlidesOuterContainer = styled.div`
  width: 100%;
  // border: 1px solid green;
  transform: rotate(15deg);

  @media ${props => props.theme.mobileDown} {
    transform: none;
  }
`

const SlidesInnerContainer = styled(motion.div)`
  width: ${props => props.slideLength * 100}%;

  @media ${props => props.theme.mobileUp} {
    display: flex;
  }

  @media ${props => props.theme.mobileDown} {
    width: 100%;
  }
`

const Button = styled.button`
  appearance: none;
  border: 0;
  background: none;
  padding: 0;
  width: 40%;

  @media ${props => props.theme.desktopDown} {
    width: 80%;
  }

  cursor: pointer;
  // border: 1px solid red;

  margin-bottom: ${rem(20)};

  &:focus {
    outline: none;
  }

  svg {
    width: 100%;
    fill: ${props => props.theme.grey};
    transition: fill 0.3s;
  }

  &:hover {
    svg {
      fill: #ff2300;
    }
  }

  @media ${props => props.theme.mobileDown} {
    display: none;
  }
`

const ControlCol = styled(Col)`
  position: relative;
  z-index: 2;
`

const NavBg = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  cursor: pointer;

  ${props =>
    props.offset === "bottom" &&
    css`
      top: -45%;
      left: ${rem(-100)};
      right: 0;
    `}

  ${props =>
    props.offset === "top" &&
    css`
      top: 45%;
      right: ${rem(-100)};
      left: 0;
    `}
`

let currentSlide = 0

const Carousel = props => {
  const projects = props.projects.map(item => ({
    slug: item.node.slug,
    layoutType: item.node.portfolio_item.previewGallery.layoutKind,
    photos: item.node.portfolio_item.previewGallery.images,
  }))

  const totalSlides = projects.length

  const [currentTransform, setCurrentTransform] = useState(0)
  // const [isAnimating, setAnimating] = useState(false)

  useEffect(() => {
    return () => {
      setCurrentTransform(0)
      currentSlide = 0
    }
  }, [])

  const changeSlide = targetSlide => {
    // let nextSlide = currentSlide + targetSlide;

    if (
      currentSlide + targetSlide < totalSlides &&
      currentSlide + targetSlide >= 0
    ) {
      //setAnimating(true)
      currentSlide += targetSlide
    }

    // console.log('should change slide')

    // currentSlide = currentSlide + targetSlide

    // if( currentSlide == 0 && targetSlide > 0 ) {
    //   currentSlide = currentSlide + targetSlide
    // }

    // if( currentSlide == 0) {
    //   currentSlide = 5
    // } else if ( currentSlide == 5 ) {
    //   currentSlide = 1
    // }

    // if
    // console.log(targetSlide)
    // if ( currentSlide == 0 )

    // calculate transform

    let transformFraction = 100 / totalSlides

    let transformAmount = -transformFraction * currentSlide

    // console.log(transformAmount)

    setCurrentTransform(transformAmount)
  }

  return (
    <Row>
      {/* <div style={{ position: 'relative', zIndex: 5 }}>
        <button onClick={ () => { changeSlide(-1) } }>prev</button><button onClick={ () => { changeSlide(1) } }>next</button>
      </div> */}

      <ControlCol lg={1}>
        <NavBg
          offset="bottom"
          onClick={() => {
            changeSlide(-1)
          }}
        />
      </ControlCol>

      <Col lg={10} md={11}>
        <SlidesOuterContainer>
          <SlidesInnerContainer
            slideLength={projects.length}
            initial={false}
            animate={{ x: currentTransform + "%" }}
            transition={{ duration: 1.2, ease: [0.77, 0, 0.18, 1] }}
            onAnimationComplete={() => {
              //setAnimating(false)
            }}
          >
            {projects.map((item, index) => (
              <React.Fragment key={index}>
                <Slide isActive={index === currentSlide} {...item} />
              </React.Fragment>
            ))}
          </SlidesInnerContainer>
        </SlidesOuterContainer>
      </Col>

      <ControlCol lg={1} md={1}>
        <motion.div
          animate={
            currentSlide === 0 ? { opacity: 0, x: -20 } : { opacity: 1, x: 0 }
          }
          transition={{ duration: 0.5 }}
        >
          <Button
            aria-label="Previous slide"
            onClick={() => {
              changeSlide(-1)
            }}
          >
            <ArrowLeft />
          </Button>
        </motion.div>

        <motion.div
          animate={
            currentSlide === projects.length - 1
              ? { opacity: 0, x: 20 }
              : { opacity: 1, x: 0 }
          }
          transition={{ duration: 0.5 }}
        >
          <Button
            aria-label="Next slide"
            onClick={() => {
              changeSlide(1)
            }}
          >
            <ArrowRight />
          </Button>
        </motion.div>

        <NavBg
          onClick={() => {
            changeSlide(1)
          }}
          offset="top"
        />
      </ControlCol>
    </Row>
  )
}

export default Carousel
